import { render } from "./DairyList.vue?vue&type=template&id=4eb98972&scoped=true"
import script from "./DairyList.vue?vue&type=script&lang=js"
export * from "./DairyList.vue?vue&type=script&lang=js"

import "./DairyList.vue?vue&type=style&index=0&id=4eb98972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb98972"]])

export default __exports__